var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-tools cw-tools-admin"
    },
    [
      _c(
        "form",
        {
          staticClass: "default",
          on: {
            submit: function submit($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("fieldset", [
            _c(
              "legend",
              [_c("translate", [_vm._v("Allgemeine Einstellungen")])],
              1
            ),
            _vm._v(" "),
            _c("label", [
              _c(
                "span",
                [_c("translate", [_vm._v("Art der Inhaltsabfolge")])],
                1
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentProgression,
                      expression: "currentProgression"
                    }
                  ],
                  staticClass: "size-s",
                  on: {
                    change: function change($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentProgression = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "0"
                      }
                    },
                    [_c("translate", [_vm._v("Frei")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "1"
                      }
                    },
                    [_c("translate", [_vm._v("Sequentiell")])],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("label", [
              _c(
                "span",
                [
                  _c("translate", [
                    _vm._v("Editierberechtigung für Tutor/-innen")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentPermissionLevel,
                      expression: "currentPermissionLevel"
                    }
                  ],
                  staticClass: "size-s",
                  on: {
                    change: function change($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentPermissionLevel = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "dozent"
                      }
                    },
                    [_c("translate", [_vm._v("Nein")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        value: "tutor"
                      }
                    },
                    [_c("translate", [_vm._v("Ja")])],
                    1
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button",
          on: {
            click: _vm.store
          }
        },
        [_c("translate", [_vm._v("Übernehmen")])],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }